import React, { useMemo } from 'react'
import { Text, VStack } from '@chakra-ui/react'

import {
    ClientFieldsFragment,
    ClientInfo,
    FilterOp,
    PatientInfo,
    useCheckExistingClientQuery,
    useGetMaybeClientsQuery,
    useQueryClientsPatientsQuery,
} from '~graphql/generated/graphql'
import { useClinic } from '~contexts/clinic-context'
import ClientItem from './client-item'
import SharedStack from '~components/shared/wrappers/shared-stack'

interface Props {
    clientInfo: ClientInfo
    patientInfo: PatientInfo
    setClient: (client: ClientFieldsFragment) => void
}

export default function SuggestedClients({
    clientInfo,
    patientInfo,
    setClient,
}: Props) {
    const { clinic } = useClinic()

    const { data: maybeClients } = useGetMaybeClientsQuery({
        variables: {
            clinicId: clinic?.id || '',
            input: {
                first_name: clientInfo.first_name || '',
                last_name: clientInfo.last_name || '',
                phone: clientInfo.phone || '',
                email: clientInfo.email || '',
                patient_name: patientInfo.patient_name || '',
            },
        },
        skip: !clinic?.id,
    })

    const clients = maybeClients?.getMaybeClients || []

    return (
        <SharedStack w="full">
            {clients.length === 0 ? (
                <Text fontWeight="semibold" alignSelf="center">
                    No suggested clients found
                </Text>
            ) : (
                <>
                    <Text fontWeight="medium" fontSize="sm">
                        Suggested Clients
                    </Text>
                    <VStack spacing={4} w="full">
                        {clients.map(client => (
                            <ClientItem
                                key={client.id}
                                client={client}
                                clientInfo={clientInfo}
                                patientInfo={patientInfo}
                                setClient={setClient}
                            />
                        ))}
                    </VStack>
                </>
            )}
        </SharedStack>
    )
}
